<div class="progress">
  @if (!uploadProgressService.isCompleted()) {
    <div
      class="progress-info"
      [class.grid-layout]="useGridLayout"
    >
      <progress
        [value]="uploadProgressService.currentProgress()"
        max="100"
      ></progress>
      <span>
        {{uploadProgressService.currentProgress()}}%
      </span>
      </div>
  } @else {
    <div class="upload-complete">
      Файл успешно загружен!
    </div>
  }
</div>
